import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Layout from "./layout/layout";
import {BrowserRouter} from "react-router-dom";
import "@fontsource/handlee";
import "@fontsource/dosis/700.css";
import "@fontsource/poppins";
import "@fontsource/pacifico";
import "@fontsource/rubik";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Layout>
          <App />
      </Layout>
    </BrowserRouter>
  </React.StrictMode>
);
